:root {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #17212b;
  background: #f7f8fa;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}
* { box-sizing: border-box; }
body { margin: 0; min-width: 320px; min-height: 100vh; }
main { width: min(920px, calc(100% - 32px)); margin: 0 auto; padding: 40px 0 64px; }
header, section { background: #fff; border: 1px solid #d7dde5; border-radius: 14px; padding: 24px; margin-bottom: 18px; }
.eyebrow { font-size: .78rem; font-weight: 700; letter-spacing: .1em; color: #315e82; }
h1 { margin: .35rem 0 .75rem; font-size: clamp(1.75rem, 5vw, 2.7rem); line-height: 1.08; }
h2 { margin-top: 0; font-size: 1.2rem; }
.boundary { border-left: 4px solid #8b5e00; padding-left: 12px; color: #5b4108; }
.status-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin: 0; }
.status-grid div { border: 1px solid #e1e5ea; border-radius: 10px; padding: 14px; }
dt { color: #52606d; font-size: .85rem; }
dd { margin: 6px 0 0; font-weight: 700; text-transform: capitalize; }
dd[data-state="ok"] { color: #17653a; }
dd[data-state="warn"] { color: #9b3c1b; }
table { width: 100%; border-collapse: collapse; }
th, td { text-align: left; vertical-align: top; padding: 10px 8px; border-bottom: 1px solid #e1e5ea; }
th { width: 150px; color: #52606d; font-weight: 600; }
.wrap-anywhere { overflow-wrap: anywhere; }
button { min-height: 44px; padding: 10px 16px; border: 1px solid #24577e; border-radius: 9px; background: #24577e; color: white; font: inherit; font-weight: 700; cursor: pointer; }
button:focus-visible { outline: 3px solid #d19b20; outline-offset: 3px; }
@media (max-width: 600px) {
  main { width: min(100% - 20px, 920px); padding-top: 20px; }
  header, section { padding: 18px; border-radius: 10px; }
  .status-grid { grid-template-columns: 1fr; }
  th { width: 110px; }
}
